export function formatPrice(price: number, noCents: boolean = false): string {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: noCents ? 0 : 2
  })
    .format(price)
    .trim()
}
